import { render, staticRenderFns } from "./caogao.vue?vue&type=template&id=43fab52b&scoped=true&"
import script from "./caogao.vue?vue&type=script&lang=js&"
export * from "./caogao.vue?vue&type=script&lang=js&"
import style0 from "./caogao.vue?vue&type=style&index=0&id=43fab52b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fab52b",
  null
  
)

export default component.exports